// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../../node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "/* Add any additional styles here */", "",{"version":3,"sources":["webpack://./resources/js/v2/modules/integrations/pages/link-marketplace/components/salla/install-app.vue"],"names":[],"mappings":"AACA,mCAAA","sourcesContent":["\n/* Add any additional styles here */\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
